import { Component, OnInit } from '@angular/core';
import { ServiceBase } from '../services-base/service.base.class';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'kts-programming',
  templateUrl: './../services-base/service.base.template.html',
  styleUrls: ['./../services-base/serivce.base.styles.scss']
})
export class ProgrammingComponent extends ServiceBase implements OnInit {

  title = 'Programming and Software';
  contents = [
    {
      subTitle: 'Programmers:',
      textcontents: [
        'Our programming specialists are trained to use a wide variety of software platforms & programming languages.',
        '<strong>Our Programming Services Include:</strong>',
        'PLC Programming & Software Design (Offline & Online)',
        'Robot Programming & Simulation (Offline & Online)'],
      imagePath: '/programing/1.jpg'
    }, {
      subTitle: 'Automation Software Programming Capabilities',
      textcontents: [
        '- Siemens Software : Step 7, WinCC, Protool, Zenon UI, Visual Basic & TIA',
        '- Allan Bradly PLC Software',
        '- Schneider PLC Software',
        '- Pheonix Contact',
        '- Pilz Safety Systems',
        '<strong>Robot Programming Platforms:</strong>',
        '- KUKA',
        '- ABB',
        '- Fanuc'],
      imagePath: '/programing/2.jpg'
    }, {
      subTitle: 'Our Skills',
      textcontents: [
        'Katiso is proud to have a reputation for having exceptional programming expertise.',
        'Our strong programming foundation has been forged from years of experience in the industry.',
        'Our high standards ensure that our clients know they can be confident in our level of service.'],
      imagePath: '/programing/3.jpg'
    }];
    constructor(meta: Meta, title: Title) {
        super();
        title.setTitle('Programming Services | Katiso Engineering and Automation');

        meta.updateTag(
            {
                name: 'keywords', content: 'Katiso, Engineering, Programming and Software, PLC Programming & Software Design, Robot Programming, Simulation, Capabilities, PLC Software, Pheonix Contact, KUKA, ABB, Pilz Safety Systems'
            }
            )
        meta.updateTag(
            {
                name: 'description', content: 'Our Programming Services Include: PLC Programming & Software Design (Offline & Online), Robot Programming & Simulation (Offline & Online) | Katiso Engineering and Automation'
            }
        )
    
    }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/app/components/services/programming/programming.component.ts